var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:("main " + _vm.classes),on:{"click":function($event){return _vm.onBody($event)}}},[(_vm.header)?_c('Header'):_vm._e(),(_vm.sidebar)?_c('Sidebar'):_vm._e(),_c('Preloader'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }